// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"37e9a18c","113":"70e8a082","142":"c432cdee","438":"b54fdf15","538":"75f67ff1","648":"455bbfe0","761":"5260b492","880":"48943040"}[chunkId] + ".chunk.js";
};